import React from 'react';
import _ from 'lodash'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ReactLoading from "react-loading";

import '../styles/App.scss';

import * as actions from '../actions/product';
import {downloadReport} from '../actions/reports'
import {loadSelectedChequeApplication, loadUserApplications} from '../actions/user';
import {menuRoutes, newAccountOpeningRoutes} from '../routers/routes';
import ProductTile from './products/ProductTile';
import Popup from './Popup';
import Application from './dashboard/Application'
import {ListSearchComponent} from './SearchComponent';
import ImpersonationRequiredMessage from './delegation/ImpersonationRequiredMessage'
import BusinessAccountInfo from './products/info/BusinessAccountInfo';
import GlobalPaymentsTrackingInfo from './products/info/GlobalPaymentsTrackingInfo'
import {fetchSelectedOnboardRequest} from '../actions/entity';
import {fetchSelectedCustodyRequest} from '../actions/custody';
import {fetchSelectedKYCRequest} from '../actions/kycMaintenance';
import GlobalMarketAccountInfo from './products/info/GlobalMarketAccountInfo';
import {fetchSelectedBolOnboardRequest} from '../actions/businessOnline';
import {fetchSelectedTPFARequest} from '../actions/tpfaActions';

const STATUS_FORMATTED = {
    'REJECTED': 'Rejected',
    'PENDING_APPROVAL': 'Pending Approval',
    'CONCLUDED': 'Concluded',
    'OPEN': 'Open'
};

const APPLICATION_TYPE_FORMATTED = {
    'CHEQUE_ACCOUNT': 'Cheque Account',
    'ENTITY_ONBOARD': 'Entity Onboard',
    'CUSTODY_ACCOUNT': 'Custody Account',
    'GLOBAL_MARKET': 'Global Market Account',
    'EBTC': 'EBTC',
    'KYC_REVIEW': 'KYC Review',
    'BOL_ONBOARD': 'Business  Online Profile',
    'TPFA_ACCOUNTS': 'TPFA Account Application',

};

const STAFF_PERMISSION = {
    provLDAP: "PROV_LDAP"
};

const MORE_INFO = {
    "Business Current Account": "businessAccount",
    globalMarket: "globalMarket",
    gpi: "gpi"
};

class HomePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataPending: true,
            isFetchingApplications: false,
            isDoneFetchingApplications: false,
            termsAccepted: false,
            filteredApplications: null,
            isSBStaff: false,
            showSBStaffUserMessage: false,
            moreInfo: {
                ["Business Current Account"]: false,
                [MORE_INFO.gpi]: false,
                [MORE_INFO.globalMarket]: false,
            }
        }
    };

    componentWillMount() {
        this._loadProducts();
        this._loadApplications();
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.user) {
            const {user} = nextProps;
            const isSBStaff = _.find(user && user.permissions, perm => (perm === STAFF_PERMISSION.provLDAP));
            this._isMounted && this.setState({isSBStaff: isSBStaff && true});
        }
    }

    handleOnContinueApplication = (event, applicationId, applicationType, onFinish) => {
        const {actions, history} = this.props;
        console.log(applicationType);
        switch (applicationType) {
            case 'CHEQUE_ACCOUNT':
                actions.loadSelectedChequeApplication(applicationId, history, onFinish);
                break;
            case 'ENTITY_ONBOARD':
                actions.fetchSelectedOnboardRequest(applicationId, history, onFinish);
                break;
            case 'CUSTODY_ACCOUNT':
                actions.fetchSelectedCustodyRequest(applicationId, history, onFinish);
                break;
            case 'KYC_REVIEW':
                actions.fetchSelectedKYCRequest(applicationId, history);
                break;
            case 'BOL_ONBOARD':
                actions.fetchSelectedBolOnboardRequest(applicationId, history, onFinish);
                break;
            case 'TPFA_ACCOUNTS':
                actions.fetchSelectedTPFARequest(applicationId, history);
                break;
            case 'GLOBAL_MARKET':
                actions.fetchSelectedGlobalMarketRequest(applicationId, history, onFinish);
                break;

        }

    };

    _loadApplications = () => {
        const {actions} = this.props;
        this.setState({isFetchingApplications: true});
        const onComplete = () => this._isMounted && this.setState({
            isFetchingApplications: false,
            isDoneFetchingApplications: true
        });
        actions.loadUserApplications(onComplete);
    };

    _loadProducts = () => {
        const {actions} = this.props;
        const onComplete = () => this._isMounted && this.setState({dataPending: false});
        actions.loadProducts(onComplete);
    };

    handleToggleSBStaffUserMessage = () => {
        this._isMounted && this.setState(prevState => ({showSBStaffUserMessage: !prevState.showSBStaffUserMessage}))
    };

    handleAllowUserToProceed = () => {
        const {impersonation} = this.props;
        const {isSBStaff} = this.state;
        const canProceed = isSBStaff ? impersonation && (impersonation.username || impersonation.firstName) : true;
        if (isSBStaff && !canProceed) {
            this.handleToggleSBStaffUserMessage();
        }
        return canProceed;
    };

    viewMenuOption = (event, path) => {
        event.preventDefault();
        if (this.handleAllowUserToProceed()) {
            const {actions, history} = this.props;
            actions.viewMenuOption(history, path);
        }
    };

    handleOnSelectProduct = (productId) => {
        if (this.handleAllowUserToProceed()) {
            const {actions, history} = this.props;
            const onProceed = () => history && history.push(newAccountOpeningRoutes.newAccount);
            actions.addProduct(productId, onProceed);
        }
    };

    handleAcceptTsAndCs = ({target}) => {
        this._isMounted && ({termsAccepted: target.checked})
    };

    handleDownloadReport = (reportName, requestBody, onComplete = null) => {
        const {actions} = this.props;
        actions.downloadReport(reportName, requestBody, onComplete, true)
    };

    onHandleFilterApplications = (searchTerm) => {
        const {applications} = this.props;
        let filteredApplications = null;
        if (searchTerm) {
            filteredApplications = _.filter(applications, ({id, applicationStatus}) => (
                    (id && id.toString().includes(searchTerm)) ||
                    (applicationStatus && applicationStatus.applicationOutcome && applicationStatus.applicationOutcome.toLowerCase().includes(searchTerm.toLowerCase()))
                )
            )
        }
        this._isMounted && this.setState({filteredApplications, searchTerm});
    };

    onToggleMoreInfoPopUps = (attribute) => {
        this._isMounted && this.setState(prevState => {
            const value = !(prevState.moreInfo && prevState.moreInfo[attribute]);
            const moreInfo = _.extend({}, prevState.moreInfo, {[attribute]: value});
            return {moreInfo}
        });
    };

    _renderHeader() {
        return (
            <div className="flexRow" style={{width: "100%", padding: 0, margin: 0}}>
                <label className="section-heading text-center">What Would You Like To Do?</label>
            </div>
        )
    }

    _renderMenuTiles() {
        const {products} = this.props;
        const {isSBStaff} = this.state;
        const hasProducts = _.size(products) > 0;
        const style = {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "flex-start",
            alignItems: "flex-start"
        };

        console.log(isSBStaff)

        return (
            <div style={style}>
                {
                    hasProducts
                    && _.map(products, (product) => (
                            <ProductTile
                                key={product.name}
                                onChange={this.handleAcceptTsAndCs}
                                onHide={this.onHide}
                                product={product}
                                selectProduct={this.handleOnSelectProduct}
                                onLearnMore={(key) => this.onToggleMoreInfoPopUps(MORE_INFO[key])}
                            />
                        )
                    )
                }

                {
                    isSBStaff ?

                        <MenuOptionCard
                            id="option7"
                            styleClass="menu-tile-btn-secondary"
                            onClickOption={(e) => this.viewMenuOption(e, menuRoutes.custody)}
                            title="Custody Account"
                            description="The Initial Functionality Will Allow You To create new custody accounts in real time"
                            showApplyNow={true}
                            isComingSoon={false}
                            isEnabled={true}

                        /> :
                        <MenuOptionCard
                            id="option7"
                            styleClass="menu-tile-btn-secondary"
                            onClickOption={(e) => this.viewMenuOption(e, menuRoutes.custody)}
                            title="Custody Account"
                            description="The Initial Functionality Will Allow You To create new custody accounts in real time"
                            showApplyNow={false}
                            isComingSoon={true}
                            isEnabled={false}

                        />
                }

                <MenuOptionCard
                    id="option10"
                    styleClass="menu-tile-btn-secondary"
                    onClickOption={(e) => this.viewMenuOption(e, menuRoutes.tpfa)}
                    title="TPFA Accounts"
                    description="Open TPFA Accounts"
                    showApplyNow={true}
                    isComingSoon={false}
                    isEnabled={true}
                />

                {/*<MenuOptionCard*/}
                {/*    id="option3"*/}
                {/*    styleClass="menu-tile-btn-secondary"*/}
                {/*    onClickOption={(e) => this.viewMenuOption(e, menuRoutes.globalmarket)}*/}
                {/*    title="Global Market Account"*/}
                {/*    description="The Initial Functionality Will Allow You To create new money market accounts in real time"*/}
                {/*    onLearnMore={() => this.onToggleMoreInfoPopUps(MORE_INFO.globalMarket)}*/}
                {/*    showApplyNow={false}*/}
                {/*    isComingSoon={true}*/}
                {/*    isEnabled={false}*/}

                {/*/>*/}


                {/*<MenuOptionCard*/}
                {/*    id="option4"*/}
                {/*    onClickOption={(e) => this.viewMenuOption(e, menuRoutes.track)}*/}
                {/*    title="Global Payments Tracking"*/}
                {/*    description="A convenient tool that allows you to track your payments’ status in real time with confirmation when the payment is credited."*/}
                {/*    onLearnMore={() => this.onToggleMoreInfoPopUps(MORE_INFO.gpi)}*/}
                {/*    isEnabled={false}*/}
                {/*/>*/}
                <br/>

                <MenuOptionCard
                    id="option5"
                    onClickOption={(e) => this.viewMenuOption(e, menuRoutes.newEntity)}
                    title="Onboard New Subsidiary/Entity"
                    description="The function allows you to load new subsidiaries to your existing organisational structure within 3 easy steps."
                    isEnabled={true}

                />

                <MenuOptionCard
                    id="option4"
                    styleClass="menu-tile-btn-secondary"
                    onClickOption={(e) => this.viewMenuOption(e, menuRoutes.businessOnline)}
                    title="Create Business Online Profile"
                    description="The function allows you to load new Business Online profile in 4 easy steps"
                    showApplyNow={false}
                    isComingSoon={true}
                    isEnabled={false}
                />

                <br/>

                <MenuOptionCard
                    id="option8"
                    styleClass="menu-tile-btn-secondary"
                    onClickOption={(e) => this.viewMenuOption(e, menuRoutes.kyc)}
                    title="KYC Review"
                    description="Review and update your Entity KYC details."
                    showApplyNow={false}
                    isComingSoon={false}
                    isEnabled={true}
                />


                <MenuOptionCard
                    id="option7"
                    styleClass="menu-tile-btn-secondary"
                    onClickOption={(e) => this.viewMenuOption(e, menuRoutes.maintenance)}
                    title="Maintenance"
                    description="The initial functionality will allow you to maintain your active account signatories."
                    isEnabled={true}
                />

                <MenuOptionCard
                    id="option6"
                    styleClass="menu-tile-btn-secondary"
                    onClickOption={(e) => this.viewMenuOption(e, menuRoutes.reporting)}
                    title="Reporting"
                    description="A quick and easy reporting tool for generating adhoc  1. Account Confirmation Letters as well as  2. Account Signatory “Audit” Reports."
                    isEnabled={true}
                />

                {/*<MenuOptionCard*/}
                {/*    id="option9"*/}
                {/*    styleClass="menu-tile-btn-secondary"*/}
                {/*    onClickOption={(e) => this.viewMenuOption(e, menuRoutes.remediation)}*/}
                {/*    title="EBTC Update"*/}
                {/*    description="Electronic Banking Terms and Conditions supporting your Business Online profile"*/}
                {/*    showApplyNow={false}*/}
                {/*    isComingSoon={false}*/}
                {/*    isEnabled={true}*/}
                {/*/>*/}


            </div>
        )
    }

    _renderRightPane() {
        const {applications} = this.props;
        const {isFetchingApplications, isDoneFetchingApplications, filteredApplications} = this.state;
        const applicationList = filteredApplications ? filteredApplications : applications;
        const hasApplications = _.size(applications) > 0;
        return (
            <div className="page-right-pane">

                <div className="product-heading"
                     style={{marginLeft: "1em", marginTop: "1em", padding: 0}}>Applications
                </div>
                <div className="title-gradient" style={{marginLeft: "1.2em"}}/>

                <div className="card-header" style={{width: "100%"}}>
                    <div style={{flex: 1}}/>
                    <ListSearchComponent
                        onFilter={this.onHandleFilterApplications}
                        placeholder="Find application..."
                    />
                </div>
                <div className="list-scroller-container" style={{backgroundColor: "transparent", height: "73vh"}}>
                    {hasApplications ?
                        _.map(applicationList, application => {
                                const status = application.applicationStatus.applicationOutcome;
                                return (
                                    <div key={`application/${application.id}`} className="selection-list-item"
                                         style={{justifyContent: "space-between"}}
                                         onClick={() => this._isMounted && this.setState({selectedApplication: application})}
                                    >
                                        <div className="flexColumn"
                                             style={{padding: 0, margin: 0, alignItems: "flex-start"}}>
                                            <span>{`${application.id}`}</span>
                                            <span>{` ${APPLICATION_TYPE_FORMATTED[application.applicationType]}`}</span>
                                        </div>
                                        <div className="flexColumn"
                                             style={{
                                                 padding: 0,
                                                 margin: 0,
                                                 justifyContent: "space-between",
                                                 alignItems: "flex-end"
                                             }}>
                                            <span className="greyText">{` ${STATUS_FORMATTED[status]}`}</span>
                                            <span className="greyText">{` ${application.createdAt}`}</span>
                                        </div>
                                    </div>
                                )
                            }
                        )
                        : (isDoneFetchingApplications && <div>You Have No Applications!</div>)
                    }
                </div>
                {
                    isFetchingApplications &&
                    <div className="inner-spinner-container">
                        <ReactLoading type="spokes" color="#444"/>
                    </div>
                }
            </div>
        )
    }

    _renderSelectedApplication() {
        const {selectedApplication} = this.state;
        if (!selectedApplication) return null;
        return (
            <Popup onClose={() => this._isMounted && this.setState({selectedApplication: null})}>
                <Application
                    application={selectedApplication}
                    title={` ${APPLICATION_TYPE_FORMATTED[selectedApplication.applicationType]}`}
                    onContinue={this.handleOnContinueApplication}
                    onDownloadReport={this.handleDownloadReport}
                    key={selectedApplication.id}
                />
            </Popup>
        )
    }

    _renderSBStaffMessage() {
        const {showSBStaffUserMessage} = this.state;
        if (!showSBStaffUserMessage) return null;
        return (
            <ImpersonationRequiredMessage onClose={this.handleToggleSBStaffUserMessage}/>
        )
    }

    _renderMoreInfoPopUps() {
        const {moreInfo} = this.state;
        if (moreInfo[MORE_INFO['Business Current Account']]) {
            return (
                <Popup onClose={() => this.onToggleMoreInfoPopUps(MORE_INFO['Business Current Account'])}>
                    <BusinessAccountInfo/>
                </Popup>
            )
        } else if (moreInfo.gpi) {
            return (
                <Popup onClose={() => this.onToggleMoreInfoPopUps(MORE_INFO.gpi)}>
                    <GlobalPaymentsTrackingInfo/>
                </Popup>
            )
        } else if (moreInfo.globalMarket) {
            return (
                <Popup onClose={() => this.onToggleMoreInfoPopUps(MORE_INFO.globalMarket)}>
                    <GlobalMarketAccountInfo/>
                </Popup>
            )
        }
        return null;
    }

    render() {
        const {dataPending} = this.state;
        const {loading} = this.props;
        if (loading || dataPending) return null;

        return (
            <div>
                <div className="page-container" style={{backgroundColor: "#fafafa"}}>
                    {this._renderHeader()}
                    <div className="home-content-container">
                        <div className="page-main-section" style={{
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            flex: 1
                        }}>
                            {this._renderMenuTiles()}
                        </div>
                        {this._renderRightPane()}
                    </div>
                </div>
                {this._renderSelectedApplication()}
                {this._renderSBStaffMessage()}
                {this._renderMoreInfoPopUps()}
            </div>
        );
    }
}

const MenuOptionCard = (props) => {
    const {id, onClickOption, title, styleClass, description, showApplyNow, isEnabled, isComingSoon, onLearnMore} = props;


    return (
        <div
            className="product-btn"
            id={id}
        >
            <div className="product-heading">
                {title}
            </div>
            <div className="title-gradient"/>
            {
                description &&
                <p style={{
                    paddingTop: "3px",
                    paddingBottom: "3px",
                    fontSize: "12px",
                    color: "#858D9D"
                }}>{description}</p>
            }
            <div style={{flex: 1}}/>
            <div className="flexRow" style={{alignItems: "flex-end", margin: 0, padding: 0}}>
                {
                    onLearnMore &&
                    <a className="flat-button-primary-light" style={{padding: 0}}
                       onClick={onLearnMore}
                       role="button"><span>Learn More</span>
                    </a>
                }
                <div style={{flex: 1}}/>
                {
                    isComingSoon ?
                        <a className="flat-button-primary" style={{padding: 0}}><span>Coming Soon</span></a> :
                        isEnabled ?
                            <a className="flat-button-primary" style={{padding: 0}}
                               onClick={onClickOption}
                               role="button">
                                {


                                    showApplyNow ? <span>Apply Now <i className="fa fa-angle-right fa-lg"/> </span> :
                                        <i className="fa fa-arrow-right"/>


                                }
                            </a>
                            :
                            <a className="flat-button-primary" style={{padding: 0}}>
                                <span> Currently Unavailable </span>
                            </a>
                }
            </div>
        </div>
    );
};

function mapStateToProps({product, loading, applications, user, impersonation}, ownProps) {
    return {
        loading,
        products: product && product.products ? product.products : [],
        applications: applications && applications.applications ? applications.applications : [],
        user: user && user.user ? user.user : {},
        impersonation: impersonation && impersonation.impersonation ? impersonation.impersonation : {},
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...actions,
            loadUserApplications,
            loadSelectedChequeApplication,
            fetchSelectedOnboardRequest,
            fetchSelectedCustodyRequest,
            fetchSelectedKYCRequest,
            fetchSelectedBolOnboardRequest,
            fetchSelectedTPFARequest,
            downloadReport
        }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
